import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = ({ value, onChange, placeholder = "Select date" }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    // ✅ Sync with parent value
    useEffect(() => {
        if (value) {
            setSelectedDate(new Date(value));
        }
    }, [value]);

    const handleChange = (date) => {
        setSelectedDate(date);
        onChange && onChange(date);
    };

    return (
        <DatePicker
            selected={selectedDate}
            onChange={handleChange}
            placeholderText={placeholder}
            dateFormat="MM/dd/yyyy"
            customInput={
                <input
                    style={{
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        width: "200px",
                        cursor: "pointer"
                    }}
                    readOnly
                />
            }
        />
    );
};

export default DateInput;